/** Shared upload guards for feed, group posts, and group media. */

export const MAX_FEED_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024; // 5MB
export const MAX_VIDEO_UPLOAD_BYTES = 1024 * 1024 * 1024; // 1GB (matches storage bucket limit)

export const formatBytesAsMb = (bytes: number): string =>
  (Math.max(0, bytes) / (1024 * 1024)).toFixed(1);

export type MediaSizeCheck =
  | { ok: true }
  | { ok: false; reason: string };

export function checkImageUploadSize(fileSizeBytes: number | null | undefined): MediaSizeCheck {
  const size = Number(fileSizeBytes) || 0;
  if (size > MAX_FEED_IMAGE_UPLOAD_BYTES) {
    return {
      ok: false,
      reason: `Image is ${formatBytesAsMb(size)}MB. Please choose an image under ${formatBytesAsMb(MAX_FEED_IMAGE_UPLOAD_BYTES)}MB.`,
    };
  }
  return { ok: true };
}

export function checkVideoUploadSize(fileSizeBytes: number | null | undefined): MediaSizeCheck {
  const size = Number(fileSizeBytes) || 0;
  if (size > MAX_VIDEO_UPLOAD_BYTES) {
    return {
      ok: false,
      reason: `Video is ${formatBytesAsMb(size)}MB. Please choose a video under ${formatBytesAsMb(MAX_VIDEO_UPLOAD_BYTES)}MB.`,
    };
  }
  return { ok: true };
}
